/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContentListResponse } from '../../models/get-content-list-response';

export interface GetContentVersions$Params {

/**
 * ID sekcie
 */
  id: number;
}

export function getContentVersions(http: HttpClient, rootUrl: string, params: GetContentVersions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContentListResponse>> {
  const rb = new RequestBuilder(rootUrl, getContentVersions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContentListResponse>;
    })
  );
}

getContentVersions.PATH = '/admin/content/{id}/version';
